import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("counters", component(opts));
  editor.BlockManager.add("counters", block(opts));
};